// Linked variants – robust: Chips als BUTTONS, kein Browser-Navigate möglich
(() => {
  const HOLDER_SEL = '#linked-variants';
  const DATA_SEL   = '#linked-variants-data';

  const q  = (s, r=document) => r.querySelector(s);
  const qa = (s, r=document) => Array.from(r.querySelectorAll(s));

  function buildChips() {
    const holder = q(HOLDER_SEL);
    const dataEl = q(DATA_SEL);
    if (!holder || !dataEl) return;

    let data;
    try { data = JSON.parse(dataEl.textContent || '{}'); } catch { return; }
    if (!data || !data.self) return;

    const items = Array.isArray(data.items) ? data.items : [];
    const all = [data.self].concat(items.filter(it => it.handle !== data.self.handle));

    holder.classList.add('LinkedVariants');
    holder.setAttribute('role', 'tablist');
    holder.innerHTML = all.map(it => {
      const active = location.pathname.includes(`/${it.handle}`);
      // WICHTIG: KEIN href – nur data-url
      return `<button type="button"
                class="LinkedVariantItem${active ? ' is-active' : ''}"
                data-url="${it.url}"
                data-handle="${it.handle}"
                role="tab"
                aria-selected="${active ? 'true' : 'false'}">
                ${it.title}
              </button>`;
    }).join('');
  }

  // Aktuelle ersetzbare Section: am sichersten die Section, die den Holder enthält
  function currentSwapEl() {
    const holder = q(HOLDER_SEL);
    if (!holder) return null;
    return holder.closest('[id^="shopify-section-"]') ||
           document.querySelector('#MainContent') ||
           document.querySelector('main[role="main"]');
  }

  function findIncomingSwapEl(doc, curr) {
    if (!curr) return null;
    if (curr.id) {
      const same = doc.getElementById(curr.id);
      if (same) return same;
    }
    return doc.querySelector('#MainContent') || doc.querySelector('main[role="main"]');
  }

  async function fetchFullHTML(url) {
    const res = await fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!res.ok) throw new Error('fetch failed');
    return res.text();
  }

  function swapWithIncoming(incoming, url) {
    const current = currentSwapEl();
    if (!incoming || !current) { window.location.assign(url); return; }

    current.replaceWith(incoming);
    history.pushState({ productUrl: url }, '', url);

    // Re-init
    buildChips();
    document.dispatchEvent(new Event('page:updated'));
    if (window.Minimog?.Theme?.init) { try { window.Minimog.Theme.init(); } catch(e){} }
  }

  // Klicks auf unsere BUTTONS
  function onChip(e) {
    const btn = e.target.closest(`${HOLDER_SEL} button.LinkedVariantItem`);
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const url = btn.getAttribute('data-url');
    // aktiv markieren
    qa(`${HOLDER_SEL} .LinkedVariantItem`).forEach(el => {
      el.classList.remove('is-active');
      el.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-selected', 'true');

    fetchFullHTML(url)
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = findIncomingSwapEl(doc, currentSwapEl());
        swapWithIncoming(incoming, url);
      })
      .catch(() => window.location.assign(url));
  }

  // Keyboard-Support (Enter/Space)
  function onKey(e) {
    if ((e.key === 'Enter' || e.key === ' ') &&
        e.target.closest(`${HOLDER_SEL} .LinkedVariantItem`)) {
      e.preventDefault();
      onChip(e);
    }
  }

  // Listener sehr früh registrieren
  document.addEventListener('click', onChip, true);
  document.addEventListener('keydown', onKey, true);

  // Back/Forward
  window.addEventListener('popstate', () => { location.reload(); });

  document.addEventListener('DOMContentLoaded', buildChips);
  document.addEventListener('page:updated', buildChips);
})();
